import { jsxs, jsx } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { styled } from "@mui/material";
import { forwardRef } from "react";
import Box from "../../../node_modules/@mui/material/Box/Box.es.js";
import Stack from "../../../node_modules/@mui/material/Stack/Stack.es.js";
import { NestedNavigation, NavigationList } from "../navigation-list/navigation-list.es.js";
const SIDEBAR_WIDTH = "16.5rem";
const SideBar = forwardRef(function Sidebar({
  logo,
  items,
  children,
  ...rest
}, ref) {
  return /* @__PURE__ */ jsxs(SideBarContainer, { ref, ...rest, children: [
    /* @__PURE__ */ jsxs(Box, { children: [
      /* @__PURE__ */ jsx(SideBarLogo, { children: logo }),
      /* @__PURE__ */ jsx(NavigationList, { disablePadding: true, children: items && /* @__PURE__ */ jsx(NestedNavigation, { navigationItems: items }) })
    ] }),
    children
  ] });
});
const SideBarContainer = styled(Stack)(({
  theme
}) => ({
  height: "100vh",
  overflowY: "auto",
  borderRight: "1px solid",
  borderRightColor: theme.palette.border.main,
  padding: `${theme.spacing(4)} ${theme.spacing(3)} ${theme.spacing(10)} ${theme.spacing(3)}`,
  width: SIDEBAR_WIDTH,
  scrollbarGutter: "stable",
  justifyContent: "space-between"
}));
const SideBarLogo = styled("div")(({
  theme
}) => ({
  height: theme.spacing(18)
}));
export {
  SideBar
};
//# sourceMappingURL=sidebar.es.js.map
